<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "OidcCallback",
  methods: {
    ...mapActions("oidcStore", ["oidcSignInCallback"])
  },
  mounted() {
    this.oidcSignInCallback()
      .then(redirectPath => {
        this.$router.push(redirectPath);
      })
      .catch(err => {
        console.error(err);
        this.logger.logtoLocal(err);
        // this.$router.push("/oidc-callback-error"); // Handle errors any way you want
        this.$router.push({ path: "/" });
      });
  }
};
</script>
